"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.164 21.566c1.108.123 2.089-.588 2.455-1.612l1.643-4.602a3.08 3.08 0 0 1-.008-.15 283.033 283.033 0 0 1-.065-5.98c0-2.134.034-4.741.062-5.872h-.043l-.032-.005a27.17 27.17 0 0 0-.705-.103 79.34 79.34 0 0 0-2.073-.259 93.847 93.847 0 0 0-6.979-.519C4.548 2.397 2.826 3.482 2.306 5.31c-.521 1.83-1.093 4.551-1.301 8.124a2.835 2.835 0 0 0 2.982 2.995 91.556 91.556 0 0 0 4.935-.372l.138 2.76c.056 1.128.626 2.27 1.821 2.54.428.097.873.163 1.283.209ZM20.182 2.41c.603 0 1.117.074 1.524.166.779.177 1.21.894 1.23 1.635.028 1.05.064 2.812.064 5.01s-.036 3.959-.064 5.009c-.02.742-.451 1.459-1.23 1.635a6.892 6.892 0 0 1-1.524.166 6.893 6.893 0 0 1-1.525-.166c-.778-.176-1.209-.893-1.229-1.635-.029-1.05-.064-2.811-.064-5.01 0-2.197.035-3.958.064-5.009.02-.741.451-1.458 1.23-1.635a6.897 6.897 0 0 1 1.524-.166Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDislike);
var _default = exports["default"] = Memo;